<template>
  <div>
    <div class="none cursors float-right" @click="handleOpen">
      <i class="el-icon-info" style="font-size: 20px"></i>
    </div>
    <el-dialog
      :title="$t('common_words.day_degree_no_unit')"
      :visible.sync="modals.read"
      :close-on-click-modal="false"
      top="2%"
    >
      <div class="mb-5" style="word-break: break-word">
        <p>
          <small>
            {{ $t('info_climates.The') }}
            <b>{{ $t('common_words.degree_day') }}</b>
            {{ $t('info_climates.heat_acumulation_info') }}
          </small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong>{{ $t('common_words.degree_day_how_to_calculate') }}</strong>
        </h6>
        <p>
          <small>
            {{ $t('info_climates.pick_base_temperature') }}
            <b>{{ $t('info_climates.base_degree') }}</b>
            {{ $t('info_climates.sensor_important_location') }}
          </small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong>{{ $t('common_words.degree_day_calculate') }}</strong>
        </h6>
        <p>
          <small>
            {{ $t('info_climates.existing_methods') }}
            <b>{{ $t('common_words.day_degree_no_unit') }}</b>
          </small>
        </p>
        <ul>
          <li>
            <b>{{ $t('info_climates.average_degree_day') }}</b
            >: {{ $t('info_climates.average_degree_result') }}
          </li>
          <li>
            <b>{{ $t('info_climates.degree_day_division') }}</b
            >:{{ $t('info_climates.degree_operation') }}
          </li>
        </ul>
        <h6 class="mt-1 mb-2">
          <strong>{{ $t('common_words.example') }}</strong>
        </h6>
        <p>
          <small> {{ $t('info_climates.base_temperature_info') }}</small>
        </p>
        <h6 class="mt-1 mb-2">
          <strong>{{ $t('common_words.applications') }}</strong>
        </h6>
        <ul>
          <li>{{ $t('info_climates.predict_blossoming_date') }}</li>
          <li>
            {{ $t('info_climates.critical_insecticide_date') }}
          </li>
          <li>{{ $t('info_climates.monitor_plague_activity') }}</li>
        </ul>
        <h6 class="mt-1 mb-2">
          <strong>{{ $t('common_words.conclusions') }}</strong>
        </h6>
        <p>
          <small>{{ $t('info_climates.degree_day_info') }} </small>
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'info-temp',
  data() {
    return {
      modals: {
        read: false,
      },
    };
  },
  methods: {
    handleOpen() {
      this.modals.read = true;
    },
  },
};
</script>
